// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PlannerTaskSubmission extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid */
  accountId?: string;
  /** String(256) */
  assigneeEmail?: string;
  /** Int32 */
  attempts!: number;
  /** String(200) */
  bucketName?: string;
  /** String */
  checklistItems?: string;
  /** DateTimeOffset */
  createdTs!: Date;
  /** String */
  description?: string;
  /** Guid */
  entityId!: string;
  /** String(60) */
  entityName!: string;
  /** String(60) */
  eventType!: string;
  /** String(200) */
  idempotencyKey!: string;
  /** String(100) */
  planId?: string;
  /** String(100) */
  plannerTaskId?: string;
  /** String(400) */
  plannerWebUrl?: string;
  /** Guid */
  proximityUserId?: string;
  /** Binary */
  rowVersion!: any;
  /** String(1000) */
  submissionError?: string;
  /** DateTimeOffset */
  submissionTs?: Date;
  /** String(255) */
  title!: string;
}

